module.exports = __webpack_public_path__ + "static/icon-c1e47e5a4ff345b6fe6fb98a4ad1e15d.png";